import { useEffect, useRef, useState } from 'react';
const _cache = new Map<string, unknown>();
export interface CachedResource<T> { data: T | undefined; loading: boolean; error: unknown; refetch: () => void; }
export function useCachedResource<T>(key: string, fetcher: () => Promise<T>): CachedResource<T> {
  const [data, setData] = useState<T | undefined>(() => _cache.get(key) as T | undefined);
  const [loading, setLoading] = useState<boolean>(() => !_cache.has(key));
  const [error, setError] = useState<unknown>(null);
  const fetcherRef = useRef(fetcher); fetcherRef.current = fetcher;
  const [nonce, setNonce] = useState(0);
  useEffect(() => {
    let active = true;
    if (_cache.has(key)) { setData(_cache.get(key) as T); setLoading(false); } else setLoading(true);
    fetcherRef.current()
      .then((d) => { if (!active) return; _cache.set(key, d); setData(d); setError(null); setLoading(false); })
      .catch((e) => { if (!active) return; setError(e); setLoading(false); });
    return () => { active = false; };
  }, [key, nonce]);
  return { data, loading, error, refetch: () => setNonce((n) => n + 1) };
}
export function invalidateCachedResource(key: string): void { _cache.delete(key); }
/** Limpia toda la caché en memoria. Pensado para aislamiento de tests. */
export function clearCachedResources(): void { _cache.clear(); }
